(function () {
  function parseRatingText(text) {
    if (!text) return null;

    var ratingMatch = text.match(/(\d+(?:\.\d+)?)\s*(?:\/\s*5|out of 5)/i);
    var countMatch = text.match(/(\d[\d,]*)\s+reviews?/i);

    if (!ratingMatch) return null;

    return {
      rating: parseFloat(ratingMatch[1]),
      count: countMatch ? parseInt(countMatch[1].replace(/,/g, ''), 10) : 0
    };
  }

  function formatRating(rating) {
    return (Math.round(rating * 10) / 10).toFixed(1);
  }

  function updateAnnouncementBar(stats) {
    if (!stats || !stats.rating) return;

    var ratingText = formatRating(stats.rating) + ' / 5 stars';
    if (stats.count > 0) {
      ratingText += ' <span class="tcb-announcement-bar__review-count">' + stats.count + ' reviews</span>';
    }

    document.querySelectorAll('.tcb-announcement-bar__rating-text').forEach(function (node) {
      if (node.closest('.tcb-announcement-bar__mobile')) {
        node.textContent = formatRating(stats.rating) + ' / 5';
      } else {
        node.innerHTML = ratingText;
      }
    });
  }

  function readHiddenStats() {
    var node = document.querySelector('[data-tcb-judgeme-stats]');
    if (!node) return null;

    var rating = parseFloat(node.getAttribute('data-rating') || '0');
    var count = parseInt(node.getAttribute('data-count') || '0', 10);

    if (!rating) return null;
    return { rating: rating, count: count || 0 };
  }

  function readJudgeMeWidget() {
    var widget = document.querySelector('.tcb-announcement-bar__jdgm-source .jdgm-all-reviews-text');
    if (!widget) return null;

    return parseRatingText(widget.textContent || widget.innerText);
  }

  function syncAnnouncementBar() {
    var widgetStats = readJudgeMeWidget();
    if (widgetStats && widgetStats.rating) {
      updateAnnouncementBar(widgetStats);
      return;
    }

    var hiddenStats = readHiddenStats();
    if (hiddenStats && hiddenStats.rating) {
      updateAnnouncementBar(hiddenStats);
    }
  }

  function waitForJudgeMe(callback) {
    var attempts = 0;

    function tick() {
      attempts += 1;

      if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') {
        window.jdgm.loadWidgets();
        callback();
        return;
      }

      if (attempts < 12) {
        window.setTimeout(tick, 500);
      }
    }

    tick();
  }

  function init() {
    var hiddenStats = readHiddenStats();
    if (hiddenStats && hiddenStats.rating) {
      updateAnnouncementBar(hiddenStats);
      return;
    }

    waitForJudgeMe(function () {
      syncAnnouncementBar();
      window.setTimeout(syncAnnouncementBar, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
